import React, {Component} from 'react';

class FJClose extends Component {

    render() {
        return (
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                 width="13px" height="13px" viewBox="0 0 13 13">
                <path fill="#FFFFFF" d="M7.914,6.5l4.783-4.783c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0
	L6.5,5.086L1.717,0.303c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L5.086,6.5l-4.783,4.783
	c-0.391,0.391-0.391,1.023,0,1.414s1.023,0.391,1.414,0L6.5,7.914l4.783,4.783c0.391,0.391,1.023,0.391,1.414,0s0.391-1.023,0-1.414
	L7.914,6.5z"/>
            </svg>
        );
    }
}

export default FJClose;